export default () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1.11585 8.75158C0.699055 8.75158 0.507232 8.23303 0.823687 7.96179L2.55625 6.47674C2.72437 6.33263 2.97245 6.33263 3.14058 6.47674L4.87314 7.96179C5.18959 8.23303 4.99777 8.75158 4.58097 8.75158H1.11585Z"
      fill="currentColor"
    />
    <path
      d="M5.06405 13.0062C7.88213 14.6341 11.4857 13.6694 13.1136 10.8514C13.2945 10.5383 13.1873 10.1378 12.8742 9.95696C12.5611 9.7761 12.1606 9.88329 11.9798 10.1964C10.7136 12.3883 7.91091 13.1385 5.71902 11.8724C4.39875 11.1097 3.60152 9.78953 3.45297 8.38117L2.14851 8.54225L2.19025 8.81897C2.45789 10.5151 3.46116 12.0802 5.06405 13.0062Z"
      fill="currentColor"
    />
    <path
      d="M14.8823 7.05928C15.2991 7.0588 15.4915 7.57712 15.1754 7.84874L13.4446 9.33581C13.2766 9.48011 13.0285 9.4804 12.8602 9.33649L11.126 7.85346C10.8092 7.58258 11.0004 7.06381 11.4172 7.06333L14.8823 7.05928Z"
      fill="currentColor"
    />
    <path
      d="M10.9291 2.80926C8.10914 1.18464 4.50671 2.1535 2.88208 4.97347C2.70158 5.28678 2.80925 5.68709 3.12255 5.86759C3.43586 6.04809 3.83617 5.94043 4.01667 5.62712C5.28029 3.43376 8.0821 2.68022 10.2755 3.94384C11.5966 4.70498 12.3954 6.02421 12.5456 7.43239L13.8499 7.26979L13.8078 6.99311C13.5382 5.29726 12.5331 3.73333 10.9291 2.80926Z"
      fill="currentColor"
    />
  </svg>
);
